import { formatDateWithLocale } from '~/common/tzUtils'
import { useIntl } from '~/components/IntlProviders'
import { Text } from '~/design_system'

/**
 * Hook for formatting a raw iso date to the user's locale without trying to change the time
 *
 * @deprecated use the useDateFormatters hook instead
 */
export const useDateTextForISODate = (
  datetime: string | Date | null | undefined,
  locale: null | string = null,
  formatOptions = {}
) => {
  const intl = useIntl()
  if (datetime == null) {
    return null
  }
  return formatDateWithLocale(datetime, locale || intl.locale, intl?.timezone, formatOptions)
}

type DateTextProps = {
  datetime?: string | Date | null
  locale?: string
  as?: any
}

// passed locale will override that of user profile
// component made for dates which shouldn't have a timezone change
/**
 * @deprecated Use the DateDisplay
 */
export const DateText = ({ datetime, locale, as = 'span' }: DateTextProps) => {
  try {
    const dateText = useDateTextForISODate(datetime, locale)
    return (
      <Text data-testid="date" as={as}>
        {dateText}
      </Text>
    )
  } catch (e) {
    console.log('non-ISO format passed to DateText:', datetime)
    return <Text as={as}>{datetime}</Text>
  }
}
